module.exports = {"441224100":"怀城镇","441224101":"闸岗镇","441224102":"坳仔镇","441224103":"汶朗镇","441224104":"甘洒镇","441224105":"凤岗镇","441224106":"洽水镇","441224107":"梁村镇","441224108":"大岗镇","441224109":"岗坪镇","441224110":"冷坑镇","441224111":"马宁镇","441224112":"蓝钟镇","441224113":"永固镇","441224114":"诗洞镇","441224115":"桥头镇","441224116":"中洲镇","441224118":"连麦镇","441224200":"下帅壮族瑶族乡","441224498":"广东省第一监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441224.json
// module id = 1841
// module chunks = 0